import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	sectionList: {
		display: 'flex',
		flexDirection: 'column',
	},
	/**
	 * Sticky bottom action bar — pins to the bottom of the page's scroll
	 * container while staying inside the editor column, so it naturally
	 * respects the left navbar and right drawer widths without hardcoded
	 * offsets.
	 */
	fixedBottomBar: {
		position: 'sticky',
		bottom: 0,
		padding: THEME.spacing.md,
		backgroundColor: THEME.colors.background.light,
		borderTop: `1px solid ${THEME.colors.border.light}`,
		zIndex: 10,
	},
	reorderButtons: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		// stretch so both buttons share the width of the wider label (equal-width buttons).
		alignItems: 'stretch',
		whiteSpace: 'nowrap',
	},
});
